import { type DbClient } from "@tanstack/react-db";
import { getViewerMessagedKits } from "@/features/provider-outreach";
import { getSavedListingIdsCollection } from "@/features/saved-listings";
import { getProfileSituation } from "@/features/viewer-profile";
import { seoMeta } from "@/lib/ui/seo";

export const viewerHomeRoute = {
    ssr: false as const,
    loader: async ({ context }: { context: { dbClient: DbClient } }) => {
        const savedListingsCollection = getSavedListingIdsCollection(
            context.dbClient,
        );
        const [profileSituation, messagedKits] = await Promise.allSettled([
            getProfileSituation(),
            getViewerMessagedKits(),
            savedListingsCollection.preload(),
        ]);
        return {
            hasSituation:
                profileSituation.status === "fulfilled"
                    ? Boolean(profileSituation.value)
                    : undefined,
            messagedKits:
                messagedKits.status === "fulfilled"
                    ? messagedKits.value
                    : undefined,
        };
    },
    head: () => ({
        ...seoMeta({
            title: "Profile — Wags",
            description: "Your Wags profile.",
            url: "/profile",
        }),
    }),
};
